export function isUndefined(val) {
  return typeof val === 'undefined';
}